import { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from '../../config';

export const downloadFileParams: AxiosRequestConfig = {
    params: {
        cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
    },
    responseType: 'blob',
    timeout: config.downloadFileTimeOut,
    headers: {
        Accept: 'application/octet-stream',
    },
};

export function createHTMLAnchorFromResponse(response: AxiosResponse, formatToJson?: boolean): HTMLAnchorElement {
    const url = getFileURL(response, formatToJson);
    const filename = getFileName(response);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    return link;
}

export function getFileURL(response: AxiosResponse, formatToJson?: boolean): string {
    const blob = formatToJson
        ? new Blob([JSON.stringify(response.data)], { type: 'application/json' })
        : new Blob([response.data]);
    return window.URL.createObjectURL(blob);
}

export function getFileName(response: any): string {
    try {
        return extractFilenameFromContentDisposition(response.headers['content-disposition']);
    } catch (e) {
        console.log('Cannot read filename', e);
        return 'newfile';
    }
}

function extractFilenameFromContentDisposition(contentDisposition: string): string {
    const filenameMark = 'filename=';
    const filenameStartPos = contentDisposition.indexOf(filenameMark) + filenameMark.length;
    const filenameEndPost = contentDisposition.indexOf(';', filenameStartPos);
    return decodeURI(
        contentDisposition
            .substr(filenameStartPos, filenameEndPost - filenameStartPos)
            .replace(/['"]*/g, '')
            .replace(/\+/g, ' '),
    );
}
